module.exports = __webpack_public_path__ + "4a82094a5b6f7fa0bfd943ccc33b6f88.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/iconfont.eot
 ** module id = 227
 ** module chunks = 0
 **/